import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const getEnumKeyByValue = <T extends Record<string, string | number>>(
  enumObj: T,
  value: T[keyof T],
): keyof T | null => {
  return (
    (Object.keys(enumObj) as Array<keyof T>).find(
      (key) => enumObj[key] === value,
    ) || null
  );
};
